import { useEffect, useRef, useState } from 'react';
import { fetchTryOnPresetsWithStaticFallback } from '@/pages/ipe/workbench/utils/tryOnSystemModelPresetFallback';

/** 节点 12.1–12.5 / 16.5：试衣系统模特 — API 优先，故障时 stale 缓存 / 静态 assets */
export function useTryOnPresets(modelType, garmentType, ethnicity) {
  const [presets, setPresets] = useState([]);
  const [source, setSource] = useState('empty');
  const [fallbackUsed, setFallbackUsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestSeqRef = useRef(0);

  useEffect(() => {
    const model = String(modelType || '').trim();
    const garment = String(garmentType || '').trim();
    if (!model || !garment) {
      setPresets([]);
      setSource('empty');
      setFallbackUsed(false);
      setLoading(false);
      setError(null);
      return undefined;
    }

    const requestSeq = requestSeqRef.current + 1;
    requestSeqRef.current = requestSeq;

    setPresets([]);
    setSource('empty');
    setFallbackUsed(false);
    setLoading(true);
    setError(null);

    let cancelled = false;

    fetchTryOnPresetsWithStaticFallback({ modelType: model, garmentType: garment, ethnicity })
      .then((result) => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setPresets(Array.isArray(result?.presets) ? result.presets : []);
        setSource(result?.source || 'empty');
        setFallbackUsed(Boolean(result?.fallbackUsed));
        setError(null);
      })
      .catch((err) => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setPresets([]);
        setSource('empty');
        setFallbackUsed(false);
        setError(err);
      })
      .finally(() => {
        if (cancelled || requestSeq !== requestSeqRef.current) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [modelType, garmentType, ethnicity]);

  return {
    presets,
    source,
    fallbackUsed,
    loading,
    error,
  };
}
